import { isMobile } from '../utils/device';

// eslint-disable-next-line
export const financesContactInfo = () => {
  const phoneNumber = '(31) 9149-1290';
  const whatsappLink = `https://${isMobile() ? 'api' : 'web'}.whatsapp.com/send?phone=553191491290`;

  return {
    phoneNumber,
    whatsappLink,
  };
};

export const supportContactInfo = () => {
  const phoneNumber = '(31) 9149-1290';
  const whatsappLink = `https://${isMobile() ? 'api' : 'web'}.whatsapp.com/send?phone=553191491290`;

  return {
    whatsappLink,
    phoneNumber,
  };
};
